<template>

  <b-col>
    <h1>Телефоны <b-button variant="primary" :to="{name: 'phone-add'}"><fa-icon icon="plus"/></b-button></h1>
    <b-overlay :show="loading">
      <b-row>
        <b-col md="3" v-for="phone in phones" :key="phone.id">
          <b-card
            class="mb-3"
            :header="formatPhone(phone.phone)"
          >
            <b-card-text>
              {{ phone.name }}
            </b-card-text>
            <b-link :to="{name: 'phone-edit', params: {projectId: projectId, phoneId: phone.id}}" class="btn btn-secondary">
              Редактировать
            </b-link>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </b-col>

</template>

<script>
import { store } from "@/store";
import Api from "@/lib/Api";
import Utils from "@/lib/Utils";


export default {
    name: 'PhoneList',
    props: [
        'projectId'
    ],
    data () {
        return {
            loading: false,
            phones: [],
            appState: store.state
        };
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    methods: {
        async loadData () {
            this.loading = true;
            try {
                const phones = await Api.getPhones(parseInt(this.projectId));
                this.phones = phones
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки телефонов', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },
        ...Utils
    }
};

</script>
